import React, { useEffect, useState } from 'react';
import '../css/ChatAdminUi.css';
import { useApiCall } from '../context/SnpApiContext';
import {
    CHATKEYNOTREGISTERED,
    ChatStatus,
    HTTP_NO_DATA,
    HTTP_SUCCESS,
    HTTP_UNAUTHORIZED,
    InternalAddRemoveChannel,
    MessageType,
} from '../utils/SnpChatConstant';
import { isEmptyData, printChatDebugLog } from '../utils/SnpChatUtils';


// const INITIAL_RUN_CHAT = [
//     { sessionId: "sfndfj", messageFrom: 'Alice', msgAt: '10:30 AM', message: 'Hello!' },
//     { sessionId: "sfdfg", messageFrom: 'Bakor', msgAt: '10:31 AM', message: 'Hello I am saksfsdjf!' },
//     { sessionId: "sffdgdfg", messageFrom: 'Bakor', msgAt: '10:31 AM', message: 'The phrase "the quick brown fox jumps over the lazy dog" is a pangram, meaning it contains every letter of the English alphabet' },
// ];

// const INITIAL_RECEIVED_CHATS = [
//     { sessionId: "Tyiefbms", messageFrom: 'Bob', msgAt: '11:15 AM', message: 'Hi there!' },
//     { sessionId: "dgfgfbms", messageFrom: 'Garda', msgAt: '11:16 AM', message: 'Hi there!' },
// ];


const ChatAdminUi = ({ handleCustomToastFunc,
    setAddRemoveItemCallback, selectedChat, setSelectedChat,
    runningChats, receivedChats, pendingChats, closeChat, setChatAdminHead,
    refreshChat, setRefreshChat, setWhoStopped
}) => {

    //{sessionId:"",message:"",messageFrom:"",messageType:"",msgAt:""}
    //const [receivedChats, setReceivedChats] = useState(INITIAL_RECEIVED_CHATS);
    //const [runningChats, setRunningChats] = useState(INITIAL_RUN_CHAT);


    const [animatingChats, setAnimatingChats] = useState([]);

    const { keyShopHash,
        getShopMessage,
        updateChatSessionDestinationDetails
    } = useApiCall();


    const handleAddRemoveItemCallback = (channel, obj) => {
        printChatDebugLog("ChatContext:handleAddRemoveItemCallback", `channel: ${channel} obj: ${obj}`);
        setAddRemoveItemCallback(channel, obj);
    };

    const handleAddToRunning = async (chat) => {
        try {
            const response = await updateChatSessionDestinationDetails(chat.sessionId);
            if (response !== null && response.status === HTTP_SUCCESS) {
                setAnimatingChats((prev) => [...prev, chat.sessionId]);

                setTimeout(() => {
                    handleAddRemoveItemCallback(InternalAddRemoveChannel.Receive_Chat_Remove, chat.sessionId);
                    handleAddRemoveItemCallback(InternalAddRemoveChannel.Running_Chat_Add, chat);
                    setAnimatingChats((prev) => prev.filter(sessionId => sessionId !== chat.sessionId));

                    setSelectedChat(chat);
                }, 1200);
            }
        } catch (err) {
            console.error("ChatContext:handleAddToRunning", err)
        }
    };


    const getRunningChat = async () => {
        try {
            const payLoad = await getShopMessage(ChatStatus.RUNNING_CHAT);
            if (payLoad !== null) {
                if (payLoad.status === HTTP_UNAUTHORIZED || payLoad.status === CHATKEYNOTREGISTERED) {
                    const msg = isEmptyData(payLoad.errorMessage) ? "Kindly registered Chat key" : payLoad.errorMessage;
                    handleCustomToastFunc("getRunningChat", msg, true);
                } else if (payLoad.status === HTTP_SUCCESS || payLoad.status === HTTP_NO_DATA) {
                    const fulldata = payLoad.payLoad.fulldata;
                    if (fulldata && Array.isArray(fulldata) && fulldata.length > 0) {
                        handleAddRemoveItemCallback(InternalAddRemoveChannel.Running_Chat_Full, fulldata);
                    } else {
                        handleAddRemoveItemCallback(InternalAddRemoveChannel.Running_Chat_Empty, []);
                        console.warn("ChatContext:No running chats are there ... ");
                    }
                }
            }
        } catch (err) {
            console.error("ChatContext:getRunningChat", err);
        }
    };

    const getRecivedChat = async (via_refresh) => {
        try {
            const payLoad = await getShopMessage(ChatStatus.NEW_RECEIVE_CHAT);
            if (payLoad !== null) {
                if (payLoad.status === HTTP_UNAUTHORIZED || payLoad.status === CHATKEYNOTREGISTERED) {
                    handleCustomToastFunc("getRecivedChat", `Kindly registered Chat key`, true);
                } else if (payLoad.status === HTTP_SUCCESS || payLoad.status === HTTP_NO_DATA) {
                    const fulldata = payLoad.payLoad.fulldata;
                    if (fulldata && Array.isArray(fulldata) && fulldata.length > 0) {
                        handleAddRemoveItemCallback(InternalAddRemoveChannel.Receive_Chat_Full, fulldata);
                    } else {
                        handleAddRemoveItemCallback(InternalAddRemoveChannel.Receive_Chat_Empty, []);
                        console.warn("ChatContext:No new chats are there ... ");
                        if (via_refresh) {
                            handleCustomToastFunc("getRecivedChat", "No new chats are there", true);
                        }
                    }
                }
            }
        } catch (err) {
            console.error("ChatContext:getRecivedChat", err);
        }
    };

    const getPendingChat = async () => {
        try {
            const payLoad = await getShopMessage(ChatStatus.STOP_BY_CUSTOMER);
            if (payLoad !== null) {
                if (payLoad.status === HTTP_UNAUTHORIZED || payLoad.status === CHATKEYNOTREGISTERED) {
                    const msg = isEmptyData(payLoad.errorMessage) ? "Kindly registered Chat key" : payLoad.errorMessage;
                    handleCustomToastFunc("getPendingChat", msg, true);
                } else if (payLoad.status === HTTP_SUCCESS || payLoad.status === HTTP_NO_DATA) {
                    const fulldata = payLoad.payLoad.fulldata;
                    if (fulldata && Array.isArray(fulldata) && fulldata.length > 0) {
                        handleAddRemoveItemCallback(InternalAddRemoveChannel.Pending_Chat_Full, fulldata);
                    } else {
                        handleAddRemoveItemCallback(InternalAddRemoveChannel.Pending_Chat_Empty, []);
                        console.warn("ChatContext:No running chats are there ... ");
                    }
                }
            }
        } catch (err) {
            console.error("ChatContext:getRunningChat", err);
        }
    };

    useEffect(() => {
        if (keyShopHash) {
            getRunningChat();
            getRecivedChat(false);
            getPendingChat();
            setChatAdminHead(true);
        } else {
            handleCustomToastFunc("keyShopHash(useEffect)", "ChatContext:Chat is not registered", true)
        }
        return () => {
            closeChat();
        }
    }, [keyShopHash]);

    useEffect(() => {
        printChatDebugLog("ChatContext:refreshChat", refreshChat);
        if (refreshChat) {
            getRunningChat();
            getRecivedChat(false);
            getPendingChat();
            setRefreshChat(false);
        }
    }, [refreshChat])

    return (
        <div className="chat-admin-ui">
            <div style={{ display: 'flex', justifyContent: 'center', margin: '10px' }}>
                <button
                    onPointerDown={() => {
                        handleCustomToastFunc("Refresh Chat", "Refreshing wait ... ", false);
                        getRunningChat();
                        getRecivedChat(true);
                        getPendingChat();
                    }}
                    style={{
                        padding: '10px 20px',
                        borderRadius: '6px',
                        border: 'none',
                        backgroundColor: '#3d5358ff',
                        color: 'white',
                        cursor: 'pointer',
                        fontWeight: 'bold'
                    }}
                >
                    Refresh Chat
                </button>
            </div>
            {runningChats.length > 0 && (
                <div className="chat-section elevated-box" style={{ backgroundColor: "#b2c1c5" }}>
                    <h2>Running Chat</h2>
                    <div className="chat-grid">
                        {runningChats.map((chat) => (
                            <div key={chat.sessionId} className="chat-card">
                                <div>
                                    <strong>{chat.messageFrom}</strong> • {chat.msgAt}
                                    <div className="chat-row">
                                        <div className="message-box">{chat.messageType === MessageType.TYPE_IMAGE ? "Sent an Image" : chat.message}</div>
                                        {
                                            (selectedChat && chat.sessionId === selectedChat.sessionId) ? (
                                                <button
                                                    onClick={() =>
                                                        closeChat()
                                                    }
                                                    className="selected-btn"
                                                >
                                                    ✖
                                                </button>
                                            ) : (
                                                <button
                                                    onClick={() =>
                                                        setSelectedChat(chat)
                                                    }
                                                    className="select-btn"
                                                >
                                                    ➤
                                                </button>
                                            )
                                        }


                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <div className="chat-section elevated-box" style={{ backgroundColor: "#99adb1" }}>
                <h2>Receive Chat</h2>
                {receivedChats.length === 0 ? (
                    <p>No chat received</p>
                ) :
                    <>
                        <div className="chat-grid">
                            {
                                receivedChats.map((chat) => (
                                    <div key={chat.sessionId} className={`chat-card ${animatingChats.includes(chat.sessionId) ? 'fade-out' : ''}`}
                                    >
                                        <div>
                                            <strong>{chat.messageFrom}</strong> • {chat.msgAt}
                                            <div className="chat-row">
                                                <div className="message-box">{chat.message}</div>
                                                <button
                                                    className={`add-btn ${animatingChats.includes(chat.sessionId) ? 'added' : ''}`}
                                                    onClick={() => handleAddToRunning(chat)}
                                                >
                                                    {animatingChats.includes(chat.sessionId) ? '✔' : '➕'}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </>
                }
            </div>
            {pendingChats.length > 0 && (
                <div className="chat-section elevated-box" style={{ backgroundColor: "#b2c1c5" }}>
                    <h2>Stop-by Customer Chat</h2>
                    <div className="chat-grid">
                        {pendingChats.map((chat) => (
                            <div key={chat.sessionId} className="chat-card">
                                <div>
                                    <strong>{chat.messageFrom}</strong> • {chat.msgAt}
                                    <div className="chat-row">
                                        <div className="message-box">{chat.messageType === MessageType.TYPE_IMAGE ? "Sent an Image" : chat.message}</div>
                                        {
                                            (selectedChat && chat.sessionId === selectedChat.sessionId) ? (
                                                <button
                                                    onClick={() =>
                                                        closeChat()
                                                    }
                                                    className="selected-btn"
                                                >
                                                    ✖
                                                </button>
                                            ) : (
                                                <button
                                                    onClick={() => {
                                                        setSelectedChat(chat);
                                                        setWhoStopped(1);
                                                    }}
                                                    className="select-btn"
                                                >
                                                    ➤
                                                </button>
                                            )
                                        }


                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ChatAdminUi;
